import createReactComponent from '../createReactComponent';
var JapaneseYen = createReactComponent('JapaneseYen', [['path', {
  d: 'M12 9.5V21m0-11.5L6 3m6 6.5L18 3',
  key: '2ej80x'
}], ['path', {
  d: 'M6 15h12',
  key: '1hwgt5'
}], ['path', {
  d: 'M6 11h12',
  key: 'wf4gp6'
}]]);
export default JapaneseYen;